import api from '../../../App/socket';
import { get } from '../../../../shared/helpers';

export const changeUserProfile = (key, value, _id) => {
    let final_key;
    if (key === 'login' || key === 'ref_user_group') final_key = key;
    else final_key = `person.${key}`;
    return api.send({
        api: 'db',
        model: 'User',
        action: 'Update',
        options: {
            update: {
                [final_key]: value,
            },
            where: { _id },
        },
    }).then(response => get(response.options, final_key)).catch(error => error);
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/requests/update_user_request.js